import { NgModule } from '@angular/core';
import { DashboardComponent } from './dashboard.component';
import { ProjectsModule } from '../projects/projects.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActionsModule } from './actions/actions.module';
import { MonthlyOverviewModule } from './monthly-overview/monthly-overview.module';
import { QuarterlyBalanceModule } from './quarterly-balance/quarterly-balance.module';
import { CompanyCostAddModule } from '../company-cost-add/company-cost-add.module';
import { FinanceDropdownModule } from '../finance-dropdown/finance-dropdown.module';
import { OpsActiveProjectsStats, OpsCompletedProjectsStats } from '@ops/storybook';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MonthlyOverviewModule,
    ActionsModule,
    ProjectsModule,
    QuarterlyBalanceModule,
    FinanceDropdownModule,
    CompanyCostAddModule,
    OpsActiveProjectsStats,
    OpsCompletedProjectsStats,
    TranslateModule,
  ],
  exports: [DashboardComponent],
  declarations: [DashboardComponent],
})
export class DashboardModule {}
